import { ParticipationGridColDef, ParticipationRecordItem } from '../../types';

export type Value = ParticipationRecordItem['investorType'];

export const investorTypeColDef: ParticipationGridColDef<Value> = {
  field: 'investorType',
  headerName: 'Investor Type',
  filter: 'agTextColumnFilter',
  floatingFilter: true,
};

// csv header to field name mapping for upload participation set
export const investorTypeHeaderMapping = {
  fieldName: 'investorType',
  displayName: 'Investor Type',
  acceptedHeaders: ['Investor Type', 'Type'],
};
